/** Polices proposées (Google Fonts + piles système courantes). */
export const HUBUP_FEED_BRAND_FONTS = [
  { value: '', label: 'Par défaut HubUP (sans style communauté)' },
  { value: 'Inter', label: 'Inter' },
  { value: 'Roboto', label: 'Roboto' },
  { value: 'Open Sans', label: 'Open Sans' },
  { value: 'Montserrat', label: 'Montserrat' },
  { value: 'Lato', label: 'Lato' },
  { value: 'Poppins', label: 'Poppins' },
  { value: 'Nunito', label: 'Nunito' },
  { value: 'Raleway', label: 'Raleway' },
  { value: 'Source Sans 3', label: 'Source Sans 3' },
  { value: 'Playfair Display', label: 'Playfair Display' },
  { value: 'Merriweather', label: 'Merriweather' },
  { value: 'Oswald', label: 'Oswald' },
  { value: 'Ubuntu', label: 'Ubuntu' },
  { value: 'Work Sans', label: 'Work Sans' },
  { value: 'DM Sans', label: 'DM Sans' },
  { value: 'Arial, sans-serif', label: 'Arial (système)' },
  { value: 'Georgia, serif', label: 'Georgia (système)' },
  { value: '"Times New Roman", Times, serif', label: 'Times (système)' },
  { value: 'system-ui, sans-serif', label: 'System UI' },
];
